import * as Yup from 'yup';

const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB
const MAX_STRING_LENGTH = 100; // Generic maximum length for text fields

const validationSchemaAdd = Yup.object().shape({
    business_name: Yup.string()
        .required('Business name is required.')
        .min(3, 'Business name must be at least 3 characters.')
        .max(100, 'Business name must not exceed 100 characters.'),

    business_type: Yup.string()
        .required('Business type is required.')
        .min(3, 'Business type must be at least 3 characters.')
        .max(50, 'Business type must not exceed 50 characters.'),

    business_category: Yup.string()
        .required('Business category is required.')
        .min(3, 'Business category must be at least 3 characters.')
        .max(50, 'Business category must not exceed 50 characters.'),

    owner_name: Yup.string()
        .required('Owner name is required.')
        .min(3, 'Owner name must be at least 3 characters.')
        .max(50, 'Owner name must not exceed 50 characters.')
        .matches(
            /^[A-Za-z ]+$/,
            'Owner name must only contain letters and spaces (no numbers or special characters).'
        ),


    email: Yup.string()
        .required('Email is required.')
        .max(100, 'Email must not exceed 100 characters.')
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            'Invalid email format.'
        ),

    mobile_number: Yup.string()
        .matches(/^[6-9]\d{9}$/, 'Enter a valid 10-digit mobile number.')
        .required('Mobile number is required.'),

    password: Yup.string()
  .required('Password is required.')
  .matches(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,20}$/,
    'Password must be 8–20 characters and include uppercase, lowercase, number, and special character.'
  ),


    account_no: Yup.string()
        .required('Account number is required.')
        .matches(/^\d{9,18}$/, 'Account number must be between 9 to 18 digits and numeric only.'),

    ifsc_code: Yup.string()
        .required('IFSC code is required.')
        .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Invalid IFSC format. Example: SBIN0001234')
        .length(11, 'IFSC code must be exactly 11 characters.'),

    passbook_name: Yup.string()
        .trim()
        .min(3, 'Passbook name must be at least 3 characters.')
        .max(50, 'Passbook name must not exceed 50 characters.')
        .matches(/^[A-Za-z ]+$/, 'Passbook name must only contain letters and spaces.')
        .required('Passbook name is required.'),

    bank_name: Yup.string()
        .trim()
        .min(3, 'Bank name must be at least 3 characters.')
        .max(100, 'Bank name must not exceed 100 characters.')
        .matches(/^[A-Za-z ]+$/, 'Bank name must only contain letters and spaces.')
        .required('Bank name is required.'),

    pan_card_number: Yup.string()
        .required('PAN number is required.')
        .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN format. Example: ABCDE1234F')
        .length(10, 'PAN number must be exactly 10 characters.'),

    gst: Yup.string()
        .trim()
        .required('GST number is required.')
        .matches(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/, 'Invalid GSTIN format. Example: 22AAAAA0000A1Z5')
        .length(15, 'GST number must be exactly 15 characters.'),

    keywords: Yup.array()
        .min(1, "Please add at least one keyword.")
        .max(10, "You can add a maximum of 10 keywords.")
        .of(Yup.string()
            .required("Keyword cannot be empty.")
            .min(2, "Keyword must be at least 2 characters.")
            .max(30, "Keyword must not exceed 30 characters.")),

    vendor_photo: Yup.mixed()
        .nullable()
        .test('fileSize', 'Vendor photo must be ≤ 2MB.', file =>
            !file || (file instanceof Blob && file.size <= MAX_FILE_SIZE)
        ),

    shop_photo: Yup.mixed()
        .nullable()
        .test('fileSize', 'Shop photo must be ≤ 2MB.', file =>
            !file || (file instanceof Blob && file.size <= MAX_FILE_SIZE)
        ),
payment_plan_id: Yup.string().required('Payment plan is required'),

    gps_photo: Yup.mixed()
        .nullable()
        .test('fileSize', 'GPS photo must be ≤ 2MB.', file =>
            !file || (file instanceof Blob && file.size <= MAX_FILE_SIZE)
        ),

    user_proof_doc: Yup.array()
        .max(2, 'Only 2 files allowed.')
        .of(
            Yup.mixed()
                .nullable()
                .test('fileSize', 'Each proof document must be ≤ 2MB.', file =>
                    !file || (file instanceof Blob && file.size <= MAX_FILE_SIZE)
                )
        ),
});

export default validationSchemaAdd;
